import type { ButtonHTMLAttributes } from 'react';

import TextInput from 'src/app/components/Form/TextInput';

export const phoneNumberMask = '999-999-9999';

interface PhoneTextInputType {
  name: string;
  label: string;
  helperText: string;
  tabIndex?: number;
  onClick?: ButtonHTMLAttributes<HTMLInputElement>['onClick'];
  data_cy?: string;
  autoFocus?: boolean;
  hasLightRedError?: boolean;
  isWhite?: boolean;
  mediumContrast?: boolean;
  hasWhiteTextOnly?: boolean;
  compactStyle?: boolean;
  disabled?: boolean;
}

const PhoneTextInput = ({
  name,
  label,
  helperText,
  tabIndex,
  onClick,
  data_cy,
  autoFocus,
  hasLightRedError,
  isWhite,
  mediumContrast,
  hasWhiteTextOnly,
  compactStyle = true,
  disabled,
}: PhoneTextInputType) => {
  return (
    <TextInput
      name={name}
      alwaysShowMask={false}
      maskChar={null}
      type="tel"
      mask={phoneNumberMask}
      label={label}
      helperText={helperText}
      compactStyle={compactStyle}
      tabIndex={tabIndex}
      onClick={onClick}
      data-cy={data_cy}
      autoFocus={autoFocus}
      hasLightRedError={hasLightRedError}
      isWhite={isWhite}
      mediumContrast={mediumContrast}
      hasWhiteTextOnly={hasWhiteTextOnly}
      disabled={disabled}
    />
  );
};

export default PhoneTextInput;
